import React from "react";
import LegalPage from "../components/LegalPage";
export default function CookiePolicy() {
  return <LegalPage tKey="cookiePolicy" testid="cookie-policy-page" />;
}
